import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm, useFieldArray, useWatch, } from "react-hook-form";
// import Loader from "../Components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { ConfirmationAlert, getOnlyToken } from "../../utils/commonFunctions";
import Loader from "../../common/Loader";
import { Tabs, Tab, Chip, Tooltip, Box, Paper } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";

export default function Workflow({ flowID, agentType, goToPreviousStep, goToNextStep, workflowid }) {
    const [currentStep, setCurrentStep] = useState(1);
    const [workflowId, setWorkflowId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fileDataArray2, setFileDataArray2] = useState([]);
    const [cosseFile, setCosseFile] = useState(null);
    const [timeGroupsList, setTimeGroupsList] = useState([]);
    const [ivrList, setIvrList] = useState([]);
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [companies, setCompanies] = useState([])
    const [successMessage, setSuccessMessage] = useState("")
    const [successModal, setSuccessModal] = useState(false)
    const navigate = useNavigate()
    const location = useLocation();
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const [workID, setworkID] = useState(obj["workflowid"] ? obj["workflowid"] : workflowid)

    const editMode = obj["isupdate"];
    const { company_id } = location.state || {};

    console.log('Company ID:', company_id);
    console.log('Edit Mode:', editMode);
    console.log('Work ID:', workID);

    const {
        register,
        control,
        handleSubmit,
        trigger,
        reset,
        clearErrors,
        getValues,
        formState: { errors },
    } = useForm({
        defaultValues: {
            timeGroups: [
                {
                    title: "",
                    startHour: "",
                    startMinute: "",
                    endHour: "",
                    endMinute: "",
                    weekStart: "",
                    weekEnd: "",
                    monthDayStart: "",
                    monthDayEnd: "",
                    monthStart: "",
                    monthEnd: "",
                    isSaved: false,
                },
            ],
        },
    });



    const { fields, append, remove, update, replace } = useFieldArray({
        control,
        name: "timeGroups",
    });


    const Req = () => <span className="text-danger ms-1">*</span>;

    useEffect(() => {
        const loadData = async () => {
            //await fetchPhoneNumbers();
            if (workID !== undefined) {
                setWorkflowId(workID);
                await fetchWorkflowData();
            }
        };
        loadData();
    }, [])

    useEffect(() => {
        //  fetchCompanies()
    }, [])


    const fetchWorkflowData = async (id = workID) => {
        setLoading(true);
        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            setLoading(true);
            const res = await axios.get(`/ivr/workflow-config/${id}/`, config);
            if (res.status === 200) {
                const data = res.data;
                setWorkflowId(id);
                reset({
                    workflowName: data.name,
                    description: data.description,
                    workflowType: data.workflow_type.charAt(0).toUpperCase() + data.workflow_type.slice(1),
                    company: data.company,
                    phoneNumber: data.phone_number ? String(data.phone_number) : "",
                    callRecording: String(data.call_recording_enabled),
                });
                // Pre-populate existing profile picture for edit mode
                if (data.agent_profile_picture) {
                    setCosseFile({ url: data.agent_profile_picture, name: 'agent_profile_picture', type: 'image/jpeg' });
                } else {
                    setCosseFile(null);
                }
            }
        } catch (error) {
            console.error("Error fetching workflow data:", error);
            setLoading(false);
        }
        setLoading(false);
    }


    const fetchTimeGroups = async () => {
        setLoading(true);
        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const resp = await axios.get(`/ivr/time-group/?work_flow=${workflowId}`, config);
        if (resp.data && resp.data.length > 0) {
            setTimeGroupsList(resp.data);
            const transformed = resp.data.map(tg => ({
                timeGroupId: tg.id,
                title: tg.name,
                startHour: tg.start_at.split(':')[0],
                startMinute: tg.start_at.split(':')[1],
                endHour: tg.end_at.split(':')[0],
                endMinute: tg.end_at.split(':')[1],
                weekStart: tg.week_start_day.charAt(0).toUpperCase() + tg.week_start_day.slice(1),
                weekEnd: tg.week_end_day.charAt(0).toUpperCase() + tg.week_end_day.slice(1),
                monthDayStart: tg.month_start_day,
                monthDayEnd: tg.month_end_day,
                monthStart: tg.start_month.charAt(0).toUpperCase() + tg.start_month.slice(1),
                monthEnd: tg.end_month.charAt(0).toUpperCase() + tg.end_month.slice(1),
                isSaved: true
            }));
            replace(transformed);
        }
        setLoading(false);
    };

    const fetchTimeConditionData = async () => {
        setLoading(true);
        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const res = await axios.get(`/ivr/time-condition-config/?work_flow=${workflowId}`, config);
            if (res.status === 200 && res.data.length > 0) {
                const tcData = res.data[0];
                const timeConditions = timeGroupsList.map(tg => {
                    const matchingCondition = tcData.time_conditions?.find(tc => tc.time_group === tg.id);
                    return {
                        ivrMatch: matchingCondition ? String(matchingCondition.destination) : ""
                    };
                });
                reset({
                    ...getValues(),
                    timeConditionName: tcData.time_condition_name,
                    timeZone: tcData.time_zone,
                    designationNonMatches: String(tcData.destination_non_matching),
                    timeConditions
                });
            }
        } catch (error) {
            console.error("Error fetching time condition data:", error);
        }
        setLoading(false);
    };
    const getIvrList = async () => {
        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const ivrResp = await axios.get(`/ivr/ivr-config/dropdown/`, config);

        if (ivrResp.status === 200) {
            setIvrList(ivrResp.data);

        }
    }
    useEffect(() => {
        if (workflowId && currentStep === 2) {
            fetchTimeGroups();
        }
        if (workflowId && currentStep === 3) {
            fetchTimeConditionData();
        }
        getIvrList();

    }, [workflowId, currentStep]);


    const steps = [
        { id: 1, label: "Profile", icon: "bi-person-badge", tooltip: "Configure basic workflow details" },
        { id: 2, label: "Time Group", icon: "bi-clock-history", tooltip: "Set up time groups for your workflow" },
        { id: 3, label: "Time Condition", icon: "bi-diagram-3", tooltip: "Configure time-based conditions" },
    ];
    const nextStep = async () => {
        if (currentStep === 1) {
            const valid = await trigger(["workflowName", "description", "callRecording"]);
            if (!valid) return;

            // Cosse file is mandatory
            if (!cosseFile) {
                setErrorMessage("Cosse File is required. Please upload an image.");
                setErrorModal(true);
                return;
            }

            const values = getValues();

            const payload = {
                // workflow_type: values.workflowType?.toLowerCase() || "inbound",
                workflow_type: agentType === 'in-bound' ? 'inbound' : 'outbound',
                name: values.workflowName,
                description: values.description,
                // company: values.company,
                call_recording_enabled: values.callRecording === "true",
                // did: values.did || null,
                // Profile picture (base64) - only for outbound agents
                ...(agentType === 'out-bound' && fileDataArray2.length > 0 && fileDataArray2[0].base64
                    ? { profile_picture: fileDataArray2[0].base64 }
                    : {}),
                // Cosse file (base64) - optional
                ...(cosseFile ? { profile_picture: cosseFile.base64 } : {}),
            };

            const token = getOnlyToken();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            try {
                setLoading(true);
                console.log('workflowId before API call:', workflowId);
                const resp = workflowId && workflowId !== 'null'
                    ? await axios.put(`/ivr/workflow-config/${workflowId}/`, payload, config)
                    : await axios.post(`/ivr/workflow-config/`, payload, config);

                if (resp.status === 200 || resp.status === 201) {
                    // handleFlowlist(resp.data.id, agentType);
                    setWorkflowId(resp.data.id);
                    setCurrentStep(2);
                    setSuccessModal(true);
                    setSuccessMessage(`${workflowId !== 'null' && workflowId ? "Workflow Updated" : "Workflow Created"} Successfully`);
                }
            } catch (error) {
                setErrorMessage(error.response?.data?.did || error.message || "Failed to save workflow");
                setErrorModal(true);
                setLoading(false);
                return;
            }
        }


        if (currentStep === 2) {
            const allSaved = fields.every((f) => f.isSaved);
            if (!allSaved) {
                // alert("Please save all Time Groups before proceeding");
                setErrorMessage("Please save all Time Groups before proceeding");
                setErrorModal(true);
                return;
            }

            await fetchTimeGroups();



            setCurrentStep(3);

            if (workflowId !== undefined) {
                await fetchTimeConditionData();
            }
        }
    };


    const prevStep = async () => {
        const newStep = currentStep - 1;
        setCurrentStep(newStep);



        if (workflowId && editMode) {
            if (newStep === 1) {
                await fetchWorkflowData(workflowId);
            } else if (newStep === 2) {
                await fetchTimeGroups();
            }
        }
    };

    const saveTimeGroup = async (index) => {
        const valid = await trigger(`timeGroups.${index}`);
        if (!valid) return;

        setLoading(true);

        const tg = getValues(`timeGroups.${index}`);

        const payload = {
            work_flow: workflowId,
            name: tg.title,
            start_at: `${tg.startHour}:${tg.startMinute}:00`,
            end_at: `${tg.endHour}:${tg.endMinute}:00`,
            week_start_day: tg.weekStart.toLowerCase(),
            week_end_day: tg.weekEnd.toLowerCase(),
            month_start_day: Number(tg.monthDayStart),
            month_end_day: Number(tg.monthDayEnd),
            start_month: tg.monthStart.toLowerCase(),
            end_month: tg.monthEnd.toLowerCase(),
        };

        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };

        if (tg.timeGroupId) {
            await axios.put(`/ivr/time-group/${tg.timeGroupId}/`, payload, config);
        } else {
            await axios.post(`/ivr/time-group/`, payload, config);
        }

        await fetchTimeGroups();
    };


    const deleteTimeGroup = async (index) => {
        const tg = fields[index];
        ConfirmationAlert(
            `Are you sure you want to delete the time group "${tg.title}"?`,
            "Delete",
            async () => {
                if (tg.timeGroupId) {
                    setLoading(true);
                    const token = getOnlyToken();
                    const config = { headers: { Authorization: `Bearer ${token}` } };
                    await axios.delete(`/ivr/time-group/${tg.timeGroupId}/`, config);
                    await fetchTimeGroups();
                } else {
                    remove(index);
                }
            }
        );
    };

    const cancelEdit = async (index) => {
        clearErrors(`timeGroups.${index}`);
        reset({
            ...getValues(),
            timeGroups: getValues().timeGroups.map((tg, i) =>
                i === index ? {} : tg
            ),
        });
        const tg = fields[index];
        if (tg.timeGroupId) {
            await fetchTimeGroups();
        } else {
            remove(index);
        }
    };

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const timeConditionsData = timeGroupsList.map((tg, index) => ({
                time_group: tg.id,
                destination: Number(data.timeConditions[index].ivrMatch)
            }));

            const payload = {
                time_condition_name: data.timeConditionName,
                work_flow: workflowId,
                time_zone: data.timeZone,
                destination_non_matching: Number(data.designationNonMatches),
                time_conditions_data: timeConditionsData
            };

            const token = getOnlyToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            if (editMode) {
                const resp = await axios.put(`ivr/time-condition-config/${workflowId}/`, payload, config);
                if (resp.status === 200 || resp.status === 201) {
                    // alert("Workflow Updated Successfully");

                    navigate('/configurations/workflowconfigurations', { state: { company_id: company_id } })
                    setSuccessModal(true);
                    setSuccessMessage("Time  Conditions updated Successfully");
                }
            }
            const res = await axios.post('/ivr/time-condition-config/', payload, config);

            if (res.status === 201 || res.status === 200) {
                setSuccessModal(true);
                setSuccessMessage("Time  Conditions Created Successfully");

                reset();
                setTimeout(() => {
                    navigate('/configurations/workflowconfigurations')
                }, 1500)
            }
            setCurrentStep(1);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setErrorMessage(error.response?.data?.message || error.message || "An error occurred while creating workflow");
            setErrorModal(true);
        }
    };

    const handleFlowlist = async (workflowId, agentTypeParam) => {
        try {

            const tokenLocal = getOnlyToken();
            const config = {
                headers: {
                    'Authorization': `Bearer ${tokenLocal}`,
                    'Content-Type': 'application/json'
                }
            }
            const payload = {
                id: flowID,
                flow_type: agentTypeParam || agentType,
            }

            // include work_flow key when a workflow id is provided
            if (workflowId) {
                payload.work_flow = workflowId;
            }

            const response = await axios.post('/api/admin/default_agent_flow/save/', payload, config);

            if (response.status === 200 || response.status === 201) {
                return true;
            }
        } catch (error) {
            console.error('Error creating agent/IVR flow:', error);

        } finally {

        }
        return false;
    }
    const weekOrder = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];

    const monthOrder = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const allowedImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/bmp", "image/svg+xml"];
    const MAX_PROFILE_SIZE = 1024 * 1024; // 1MB

    const handleFileChangePrfile = (event) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;
        const fileList = Array.from(files);
        const invalidFiles = fileList.filter(file => !allowedImageTypes.includes(file.type));
        if (invalidFiles.length > 0) {
            alert(`Only image files are allowed. Invalid: ${invalidFiles.map(f => f.name).join(', ')}`);
            event.target.value = '';
            setFileDataArray2([]);
            return;
        }
        const oversizedFiles = fileList.filter(file => file.size > MAX_PROFILE_SIZE);
        if (oversizedFiles.length > 0) {
            alert(`Each file must be under 1MB. Oversized: ${oversizedFiles.map(f => f.name).join(', ')}`);
            event.target.value = '';
            setFileDataArray2([]);
            return;
        }
        const results = [];
        let loadedCount = 0;
        fileList.forEach((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                results.push({ base64: reader.result, name: file.name, type: file.type });
                loadedCount++;
                if (loadedCount === fileList.length) setFileDataArray2(results);
            };
        });
    };

    const handleCosseFileChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        if (!allowedImageTypes.includes(file.type)) {
            alert(`Only image files are allowed. Invalid: ${file.name}`);
            event.target.value = '';
            setCosseFile(null);
            return;
        }
        if (file.size > MAX_PROFILE_SIZE) {
            alert(`File must be under 1MB. Oversized: ${file.name}`);
            event.target.value = '';
            setCosseFile(null);
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCosseFile({ base64: reader.result, name: file.name, type: file.type });
        };
    };

    const isTimeValid = (startH, startM, endH, endM) => {
        if (!startH || !startM || !endH || !endM) return true;
        return `${endH}${endM}` >= `${startH}${startM}`;
    };

    const isRangeValid = (start, end, list) => {
        if (!start || !end) return true;
        return list.indexOf(end) >= list.indexOf(start);
    };

    const timeGroupsWatch = useWatch({
        control,
        name: "timeGroups",
    });

    return (
        <>
            <div id='layout-wrapper'>
                <Header />
                <Sidebar />
                <div className='page-content'>

                    <div className="main-content">
                        {loading ?
                            <div
                                className="full-page-loader-overlay"
                            >
                                <Loader />
                            </div>
                            :
                            <div className="  ">

                                <div className="d-flex justify-content-between align-items-center">
                                    <h4 style={{ color: "#014670" }} className="fw-bold  mb-4">{workflowId ? "Edit Workflow" : "Create Workflow"}</h4>
                                    <button
                                        onClick={() => navigate('/configurations/workflowconfigurations')}
                                        className="btn btn-primary btn-sm d-flex fs-6 align-items-center gap-1 px-3"
                                    >
                                        <i className="bi bi-arrow-left"></i>
                                        Back
                                    </button>
                                </div>
                                {/* ================= STEPPER - Material-UI Tabs Design ================= */}
                                <Paper sx={{ mb: 3 }}>
                                    <Tabs
                                        value={currentStep - 1}
                                        onChange={(_, newValue) => setCurrentStep(newValue + 1)}
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: 'divider',
                                            backgroundColor: '#ffffff'
                                        }}
                                        variant="fullWidth"
                                        scrollButtons="auto"
                                    >
                                        {steps.map((stepItem, index) => (
                                            <Tooltip key={stepItem.id} title={stepItem.tooltip || stepItem.label} arrow placement="top">
                                                <Tab
                                                    value={index}
                                                    label={
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Chip
                                                                label={index + 1}
                                                                size="small"
                                                                sx={{
                                                                    bgcolor: currentStep > stepItem.id ? '#014670' : currentStep === stepItem.id ? '#014670' : '#adb5bd',
                                                                    color: 'white',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.75rem'
                                                                }}
                                                            />
                                                            {stepItem.icon && (
                                                                <i
                                                                    className={`bi ${stepItem.icon}`}
                                                                    style={{
                                                                        fontSize: "20px",
                                                                        color: currentStep === stepItem.id ? "#1976D2" : "#6c757d",
                                                                    }}
                                                                />
                                                            )}
                                                            <span style={{
                                                                color: currentStep === stepItem.id ? "#1976D2" : "#6c757d",
                                                                fontWeight: 500,
                                                            }} >{stepItem.label}</span>
                                                        </Box>
                                                    }
                                                    disabled={workID !== undefined ? false : true}
                                                />
                                            </Tooltip>
                                        ))}
                                    </Tabs>
                                </Paper>


                                {/* ================= FORM ================= */}
                                <div className=" border-0  rounded-4  px-3 py-3 ">
                                    <div className=" ">

                                        {/* -------- STEP 1 -------- */}
                                        {currentStep === 1 && (
                                            <>

                                                {/* ===== BLOCK ROW 1 ===== */}
                                                <div className="row g-4 mb-4">

                                                    {/* ===== BLOCK 1: WORKFLOW DETAILS ===== */}
                                                    <div className="col-md-6">
                                                        <div className="p-4 bg-white border rounded-3">
                                                            <h5 className="mb-4">
                                                                <i className="bi bi-file-earmark-text" style={{ color: '#014670', marginRight: '8px' }}></i>
                                                                Workflow Details
                                                                <Tooltip title="Configure basic workflow information and recording settings" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>

                                                            {/* Workflow Name */}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Workflow Name <span className="text-danger">*</span>
                                                                    <Tooltip title="Enter a unique name for your workflow (e.g., 'Office Hours', 'Support Flow')" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <input
                                                                    className="form-control "
                                                                    placeholder="Please enter Workflow name"
                                                                    {...register("workflowName", {
                                                                        required: "Workflow name is required",
                                                                    })}
                                                                />
                                                                <small className="text-danger">
                                                                    {errors.workflowName?.message}
                                                                </small>
                                                            </div>

                                                            {/* Call Recording */}
                                                            <div className="mb-3">
                                                                <label className="form-label d-block">
                                                                    Call Recording  <span className="text-danger">*</span>
                                                                    <Tooltip title="Enable or disable automatic recording of all calls in this workflow" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <div className="d-flex align-items-center gap-4 ">
                                                                    <div className="form-check">
                                                                        <input
                                                                            type="radio"
                                                                            value="true"
                                                                            id="on"
                                                                            className="form-check-input"
                                                                            {...register("callRecording", {
                                                                                required: "Call recording selection is required",
                                                                            })}
                                                                        />
                                                                        <label htmlFor="on" className="form-check-label">
                                                                            ON
                                                                        </label>
                                                                    </div>

                                                                    <div className="form-check">
                                                                        <input
                                                                            type="radio"
                                                                            value="false"
                                                                            id="off"
                                                                            className="form-check-input"
                                                                            {...register("callRecording", {
                                                                                required: "Call recording selection is required",
                                                                            })}
                                                                        />
                                                                        <label htmlFor="off" className="form-check-label">
                                                                            OFF
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <small className="text-danger d-block mt-1">
                                                                    {errors.callRecording?.message}
                                                                </small>
                                                            </div>

                                                            {/* Cosse File Upload */}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Choose File <span className="text-danger">*</span>
                                                                    <Tooltip title="Upload a profile image for the cosse (max 1MB, image files only)" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <div className="d-flex align-items-start gap-3 flex-wrap">
                                                                    <div>
                                                                        <input
                                                                            type="file"
                                                                            id="CosseFileUpload"
                                                                            accept="image/*"
                                                                            className="form-control"
                                                                            style={{ maxWidth: '280px' }}
                                                                            onChange={handleCosseFileChange}
                                                                        />
                                                                        <small className="text-muted d-block mt-1">Accepted: JPG, PNG, GIF, WEBP, BMP, SVG &bull; Max size: 1MB</small>
                                                                        {!cosseFile && <small className="text-danger d-block mt-1">Cosse file is required</small>}
                                                                    </div>
                                                                    {cosseFile && (
                                                                        <div className="position-relative" style={{ width: '64px', height: '64px' }}>
                                                                            <img
                                                                                src={cosseFile.base64 || cosseFile.url}
                                                                                alt="Cosse Preview"
                                                                                style={{
                                                                                    width: '64px',
                                                                                    height: '64px',
                                                                                    objectFit: 'cover',
                                                                                    borderRadius: '50%',
                                                                                    border: '2px solid #014670'
                                                                                }}
                                                                            />
                                                                            <button
                                                                                type="button"
                                                                                title="Remove"
                                                                                onClick={() => setCosseFile(null)}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '-6px',
                                                                                    right: '-6px',
                                                                                    width: '20px',
                                                                                    height: '20px',
                                                                                    borderRadius: '50%',
                                                                                    border: 'none',
                                                                                    background: '#dc3545',
                                                                                    color: '#fff',
                                                                                    fontSize: '12px',
                                                                                    lineHeight: 1,
                                                                                    cursor: 'pointer',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}
                                                                            >
                                                                                &times;
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Profile Picture Upload - only for Outbound */}
                                                            {agentType === 'out-bound' && (
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Profile Picture
                                                                        <Tooltip title="Upload a profile picture for this outbound workflow agent (max 1MB, image files only)" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <div className="d-flex align-items-start gap-3 flex-wrap">
                                                                        <div>
                                                                            <input
                                                                                type="file"
                                                                                id="WorkflowProfilePic"
                                                                                accept="image/*"
                                                                                className="form-control"
                                                                                style={{ maxWidth: '280px' }}
                                                                                onChange={handleFileChangePrfile}
                                                                            />
                                                                            <small className="text-muted d-block mt-1">Accepted: JPG, PNG, GIF, WEBP, BMP, SVG &bull; Max size: 1MB</small>
                                                                        </div>
                                                                        {fileDataArray2.length > 0 && (
                                                                            <div className="position-relative" style={{ width: '64px', height: '64px' }}>
                                                                                <img
                                                                                    src={fileDataArray2[0].base64 || fileDataArray2[0].url}
                                                                                    alt="Profile Preview"
                                                                                    style={{
                                                                                        width: '64px',
                                                                                        height: '64px',
                                                                                        objectFit: 'cover',
                                                                                        borderRadius: '50%',
                                                                                        border: '2px solid #014670'
                                                                                    }}
                                                                                />
                                                                                <button
                                                                                    type="button"
                                                                                    title="Remove"
                                                                                    onClick={() => setFileDataArray2([])}
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: '-6px',
                                                                                        right: '-6px',
                                                                                        width: '20px',
                                                                                        height: '20px',
                                                                                        borderRadius: '50%',
                                                                                        border: 'none',
                                                                                        background: '#dc3545',
                                                                                        color: '#fff',
                                                                                        fontSize: '12px',
                                                                                        lineHeight: 1,
                                                                                        cursor: 'pointer',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                >
                                                                                    &times;
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>

                                                    {/* ===== BLOCK 2: DESCRIPTION ===== */}
                                                    <div className="col-md-6">
                                                        <div className="p-4 bg-white border rounded-3">
                                                            <h5 className="mb-4">
                                                                <i className="bi bi-file-text" style={{ color: '#014670', marginRight: '8px' }}></i>
                                                                Description
                                                                <Tooltip title="Provide detailed information about your workflow" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>

                                                            <label className="form-label">
                                                                Description <span className="text-danger">*</span>
                                                                <Tooltip title="Provide a detailed description of the workflow purpose and configuration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </label>
                                                            <textarea
                                                                rows={5}
                                                                placeholder="Please enter the Workflow description here"
                                                                className="form-control"
                                                                {...register("description", {
                                                                    required: "Description is required",
                                                                })}
                                                            />
                                                            <small className="text-muted">Detailed description of the workflow purpose and configuration.</small>
                                                            <small className="text-danger">
                                                                {errors.description?.message}
                                                            </small>

                                                        </div>
                                                    </div>

                                                </div>

                                            </>


                                        )}


                                        {currentStep === 2 && (

                                            <>

                                                <div className="">
                                                    {/* ===== SECTION HEADER ===== */}
                                                    <div className="mb-4">
                                                        <h5>
                                                            <i className="bi bi-clock-history" style={{ color: '#014670', marginRight: '8px' }}></i>
                                                            Time Groups
                                                            <Tooltip title="Create and configure time groups to define when different routing rules apply" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                    </div>

                                                    {fields.map((item, index) => {
                                                        const tg = timeGroupsWatch?.[index] || {};

                                                        return (
                                                            <div
                                                                key={item.id}
                                                                className="p-4 bg-white border rounded-3 mb-4"
                                                                style={{ borderColor: "#d9e2ef" }}
                                                            >

                                                                {/* ===== ROW 1 : TITLE ===== */}
                                                                <div className="row mb-4">
                                                                    <div className="col-md-4">
                                                                        <label className="form-label fw-medium">
                                                                            Time Group Title <Req />
                                                                            <Tooltip title="Enter a descriptive name for this time group (e.g., 'Working Hours', 'Holiday')" arrow placement="top">
                                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        </label>
                                                                        <input
                                                                            placeholder="Eg: Working Hours"
                                                                            disabled={item.isSaved}
                                                                            className="form-control"
                                                                            {...register(`timeGroups.${index}.title`, {
                                                                                required: "Title is required",
                                                                            })}
                                                                        />
                                                                        <small className="text-danger">
                                                                            {errors?.timeGroups?.[index]?.title?.message}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                {/* ===== ROW 2 : TIME RANGE + WEEK ===== */}
                                                                <div className="row mb-4 align-items-end">

                                                                    {/* TIME RANGE */}
                                                                    <div className="col-md-6">
                                                                        <label className="form-label fw-medium">
                                                                            Time range <Req />
                                                                            <Tooltip title="Select the start and end time for this time group (24-hour format)" arrow placement="top">
                                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        </label>

                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.startHour`, {
                                                                                    required: "Start hour is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Hours *</option>
                                                                                {Array.from({ length: 24 }, (_, i) => (
                                                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                                                        {String(i).padStart(2, "0")}
                                                                                    </option>
                                                                                ))}
                                                                            </select>

                                                                            <span>:</span>

                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.startMinute`, {
                                                                                    required: "Start minute is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Minutes *</option>
                                                                                {["00", "15", "30", "45"].map(m => (
                                                                                    <option key={m} value={m}>{m}</option>
                                                                                ))}
                                                                            </select>

                                                                            <span className="mx-1">to</span>

                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.endHour`, {
                                                                                    required: "End hour is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Hours *</option>
                                                                                {Array.from({ length: 24 }, (_, i) => (
                                                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                                                        {String(i).padStart(2, "0")}
                                                                                    </option>
                                                                                ))}
                                                                            </select>

                                                                            <span>:</span>

                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.endMinute`, {
                                                                                    required: "End minute is required",
                                                                                    validate: () =>
                                                                                        isTimeValid(
                                                                                            tg.startHour,
                                                                                            tg.startMinute,
                                                                                            tg.endHour,
                                                                                            tg.endMinute
                                                                                        ) || "Finish time cannot be before start time",
                                                                                })}
                                                                            >
                                                                                <option value="">Minutes *</option>
                                                                                {["00", "15", "30", "45"].map(m => (
                                                                                    <option key={m} value={m}>{m}</option>
                                                                                ))}
                                                                            </select>
                                                                        </div>

                                                                        {/* TIME RANGE ERROR */}
                                                                        <small className="text-danger d-block mt-1">
                                                                            {errors?.timeGroups?.[index]?.startHour?.message ||
                                                                                errors?.timeGroups?.[index]?.startMinute?.message ||
                                                                                errors?.timeGroups?.[index]?.endHour?.message ||
                                                                                errors?.timeGroups?.[index]?.endMinute?.message}
                                                                        </small>
                                                                    </div>

                                                                    {/* DAYS OF WEEK */}
                                                                    <div className="col-md-6">
                                                                        <label className="form-label fw-medium">
                                                                            Days of Week <Req />
                                                                            <Tooltip title="Select the range of days this time group applies to (Monday to Friday, etc.)" arrow placement="top">
                                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        </label>

                                                                        <div className="d-flex gap-2">
                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.weekStart`, {
                                                                                    required: "Week start is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Start *</option>
                                                                                {weekOrder.map(d => (
                                                                                    <option key={d} value={d}>{d}</option>
                                                                                ))}
                                                                            </select>

                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.weekEnd`, {
                                                                                    required: "Week end is required",
                                                                                    validate: v =>
                                                                                        isRangeValid(tg.weekStart, v, weekOrder) ||
                                                                                        "Week end cannot be before start",
                                                                                })}
                                                                            >
                                                                                <option value="">End *</option>
                                                                                {weekOrder.map(d => (
                                                                                    <option key={d} value={d}>{d}</option>
                                                                                ))}
                                                                            </select>
                                                                        </div>

                                                                        <small className="text-danger">
                                                                            {errors?.timeGroups?.[index]?.weekEnd?.message}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                {/* ===== ROW 3 : MONTHS + DAYS OF MONTH ===== */}
                                                                <div className="row mb-4 align-items-end">

                                                                    {/* MONTHS */}
                                                                    <div className="col-md-6">
                                                                        <label className="form-label fw-medium">
                                                                            Months <Req />
                                                                            <Tooltip title="Select the range of months this time group applies to" arrow placement="top">
                                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        </label>

                                                                        <div className="d-flex gap-2">
                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.monthStart`, {
                                                                                    required: "Month start is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Start *</option>
                                                                                {monthOrder.map(m => (
                                                                                    <option key={m} value={m}>{m}</option>
                                                                                ))}
                                                                            </select>

                                                                            <select
                                                                                disabled={item.isSaved}
                                                                                className="form-select"
                                                                                {...register(`timeGroups.${index}.monthEnd`, {
                                                                                    required: "Month end is required",
                                                                                    validate: v =>
                                                                                        isRangeValid(tg.monthStart, v, monthOrder) ||
                                                                                        "Month end cannot be before start",
                                                                                })}
                                                                            >
                                                                                <option value="">End *</option>
                                                                                {monthOrder.map(m => (
                                                                                    <option key={m} value={m}>{m}</option>
                                                                                ))}
                                                                            </select>
                                                                        </div>

                                                                        <small className="text-danger">
                                                                            {errors?.timeGroups?.[index]?.monthEnd?.message}
                                                                        </small>
                                                                    </div>

                                                                    {/* DAYS OF MONTH */}
                                                                    <div className="col-md-6">
                                                                        <label className="form-label fw-medium">
                                                                            Days of Month <Req />
                                                                            <Tooltip title="Enter the starting and ending day of the month (1-31) this time group applies to" arrow placement="top">
                                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        </label>

                                                                        <div className="d-flex gap-2">
                                                                            <input
                                                                                type="number"
                                                                                disabled={item.isSaved}
                                                                                className="form-control"
                                                                                placeholder="Start *"
                                                                                {...register(`timeGroups.${index}.monthDayStart`, {
                                                                                    required: "Start day is required",
                                                                                    min: { value: 1, message: "Minimum day is 1" },
                                                                                    max: { value: 31, message: "Maximum day is 31" },
                                                                                })}
                                                                            />

                                                                            <input
                                                                                type="number"
                                                                                disabled={item.isSaved}
                                                                                className="form-control"
                                                                                placeholder="End *"
                                                                                {...register(`timeGroups.${index}.monthDayEnd`, {
                                                                                    required: "End day is required",
                                                                                    min: { value: 1, message: "Minimum day is 1" },
                                                                                    max: { value: 31, message: "Maximum day is 31" },
                                                                                    validate: v =>
                                                                                        Number(v) >= Number(tg.monthDayStart) ||
                                                                                        "End day cannot be before start",
                                                                                })}
                                                                            />
                                                                        </div>

                                                                        <small className="text-danger">
                                                                            {errors?.timeGroups?.[index]?.monthDayEnd?.message}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                {/* ===== FOOTER ACTIONS (UNCHANGED) ===== */}
                                                                {!item.isSaved && (
                                                                    <div className="d-flex justify-content-end gap-3">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger"
                                                                            onClick={() => cancelEdit(index)}
                                                                        >
                                                                            Cancel
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={() => saveTimeGroup(index, item)}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {item.isSaved && (
                                                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                                                        <div className="text-success fw-semibold">
                                                                            <i className="bi bi-check-circle me-1"></i>
                                                                            Time Group Saved
                                                                        </div>
                                                                        <div className="d-flex gap-2">
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                onClick={() => update(index, { ...item, isSaved: false })}
                                                                            >
                                                                                <i className="bi bi-pencil"></i>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-danger"
                                                                                onClick={() => deleteTimeGroup(index)}
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>



                                                        );
                                                    })}

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() =>
                                                            append({
                                                                title: "",
                                                                startHour: "",
                                                                startMinute: "",
                                                                endHour: "",
                                                                endMinute: "",
                                                                weekStart: "",
                                                                weekEnd: "",
                                                                monthDayStart: "",
                                                                monthDayEnd: "",
                                                                monthStart: "",
                                                                monthEnd: "",
                                                                isSaved: false,
                                                            })
                                                        }
                                                    >
                                                        <i className="bi bi-plus-lg me-1"></i>
                                                        ADD TIME GROUP
                                                    </button>
                                                </div>
                                            </>
                                        )}




                                        {/* -------- STEP 3 -------- */}
                                        {currentStep === 3 && (
                                            <>

                                                {/* ===== BLOCK ROW: TIME CONDITION SETTINGS + ROUTING ===== */}
                                                <div className="row g-4 mb-4">

                                                    {/* ===== BLOCK 1: TIME CONDITION SETTINGS ===== */}
                                                    <div className="col-md-6">
                                                        <div className="p-4 bg-white border rounded-3 h-100">
                                                            <h5 className="mb-4">
                                                                <i className="bi bi-clock-history" style={{ color: '#014670', marginRight: '8px' }}></i>
                                                                Time Condition Settings
                                                                <Tooltip title="Configure the time condition name, timezone, and default destination" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>

                                                            {/* Time Condition Name */}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Time Condition Name <span className="text-danger">*</span>
                                                                    <Tooltip title="Enter a descriptive name for this time condition (e.g., 'Support – Working Hours')" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <input
                                                                    placeholder="Eg: Support – Working Hours"
                                                                    type="text"
                                                                    className="form-control "
                                                                    {...register("timeConditionName", {
                                                                        required: "Time condition name is required",
                                                                    })}
                                                                />
                                                                <small className="text-danger">
                                                                    {errors.timeConditionName?.message}
                                                                </small>
                                                            </div>

                                                            {/* Row: Time Zone + Destination NON Matches */}
                                                            <div className="row g-3 mb-3">
                                                                {/* Time Zone */}
                                                                <div className="col-md-6">
                                                                    <label className="form-label">
                                                                        Time Zone <span className="text-danger">*</span>
                                                                        <Tooltip title="Select the time zone for this time condition (IST, EST, GMT, etc.)" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <select
                                                                        className="form-select "
                                                                        {...register("timeZone", { required: "Time zone is required" })}
                                                                    >
                                                                        <option value="">-- Select Time Zone --</option>
                                                                        <option value="IST">IST</option>
                                                                        <option value="EST">EST</option>
                                                                        <option value="GMT">GMT</option>
                                                                        <option value="PST">PST</option>
                                                                        <option value="CET">CET</option>
                                                                        <option value="UST">UST</option>
                                                                        <option value="UTC">UTC</option>
                                                                    </select>
                                                                    <small className="text-danger">{errors.timeZone?.message}</small>
                                                                </div>

                                                                {/* Destination NON Matches */}
                                                                <div className="col-md-6">
                                                                    <label className="form-label">
                                                                        Destination NON Matches (IVR) <span className="text-danger">*</span>
                                                                        <Tooltip title="Select the IVR destination for calls that don't match any time condition" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <select
                                                                        className="form-select "
                                                                        {...register("designationNonMatches", {
                                                                            required: "Required",
                                                                        })}
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {ivrList?.map((ivr) => (
                                                                            <option key={ivr.id} value={ivr.id}>
                                                                                {ivr.ivr_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <small className="text-danger">
                                                                        {errors.designationNonMatches?.message}
                                                                    </small>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* ===== BLOCK 2: TIME CONDITIONS ROUTING ===== */}
                                                    <div className="col-md-6">
                                                        <div className="p-4 bg-white border rounded-3 h-100">
                                                            <h5 className="mb-4">
                                                                <i className="bi bi-arrow-left-right" style={{ color: '#014670', marginRight: '8px' }}></i>
                                                                Time Condition Routing
                                                                <Tooltip title="Map each time group to its corresponding IVR destination" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>

                                                            <div className="row g-3">
                                                                {timeGroupsList &&
                                                                    timeGroupsList.map((tg, index) => (
                                                                        <div
                                                                            key={tg.id}
                                                                            className="col-md-6"
                                                                        >
                                                                            {/* ===== LABEL + BADGE ===== */}
                                                                            <label className="form-label d-flex align-items-center gap-2 flex-wrap">
                                                                                Destination IVR
                                                                                <span className="d-inline-flex align-items-center">
                                                                                    <span className="text-muted">(</span>
                                                                                    <span className="badge rounded-pill bg-primary-subtle text-primary mx-1">
                                                                                        {tg.name}
                                                                                    </span>
                                                                                    <span className="text-muted">)</span>
                                                                                </span>
                                                                                <span className="text-danger">*</span>
                                                                                <Tooltip title="Select the IVR destination for this time group" arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>



                                                                            {/* ===== SELECT ===== */}
                                                                            <select
                                                                                className="form-select"
                                                                                {...register(`timeConditions.${index}.ivrMatch`, {
                                                                                    required: "IVR is required",
                                                                                })}
                                                                            >
                                                                                <option value="">Select IVR</option>
                                                                                {ivrList?.map((ivr) => (
                                                                                    <option key={ivr.id} value={ivr.id}>
                                                                                        {ivr.ivr_name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>

                                                                            {/* ===== ERROR ===== */}
                                                                            <small className="text-danger">
                                                                                {errors?.timeConditions?.[index]?.ivrMatch?.message}
                                                                            </small>
                                                                        </div>
                                                                    ))}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </>

                                        )}


                                        {/* -------- ACTIONS -------- */}
                                        <div className="d-flex justify-content-end align-items-center gap-2 mt-4 pt-3">
                                            {editMode && <button
                                                className="btn btn-outline-primary"
                                                onClick={goToPreviousStep}
                                            >
                                                Previous step
                                            </button>}
                                            {workID !== undefined && currentStep < 3 && (
                                                <button
                                                    className="btn btn-outline-warning"
                                                    onClick={() => setCurrentStep(currentStep + 1)}
                                                >
                                                    Skip
                                                </button>
                                            )}
                                            {currentStep > 1 && (
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={prevStep}
                                                >
                                                    Back
                                                </button>
                                            )}

                                            {currentStep < 3 ? (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={nextStep}
                                                >
                                                    Save & Next
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={handleSubmit(onSubmit)}
                                                >
                                                    {workID !== undefined ? "Update Workflow" : "Create Workflow"}
                                                </button>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>

                        }

                        <Modal
                            show={errorModal}
                            onHide={() => setErrorModal(false)}
                            centered
                            backdrop="static"
                        >
                            <Modal.Body className="text-center p-4">
                                {/* Icon */}
                                <div className="mb-3">
                                    <div
                                        className="rounded-circle d-inline-flex align-items-center justify-content-center border border-danger "
                                        style={{ width: 56, height: 56 }}
                                    >
                                        <i className="bi bi-exclamation-lg fs-3 text-danger"></i>
                                    </div>
                                </div>

                                {/* Title */}
                                <h5 className="fw-semibold mb-2">Something went wrong</h5>

                                {/* Message */}
                                <p className="text-muted mb-4">
                                    {errorMessage || "We couldn’t complete the action. Please try again."}
                                </p>

                                {/* Action */}
                                <button
                                    className="btn btn-danger px-4"
                                    onClick={() => setErrorModal(false)}
                                >
                                    Okay
                                </button>
                            </Modal.Body>
                        </Modal>




                        {/* SUCCESS MODAL */}
                        <Modal
                            show={successModal}
                            onHide={() => setSuccessModal(false)}
                            centered
                            backdrop="static"
                            contentClassName="border-0 shadow-lg rounded-4"
                        >
                            <Modal.Body className="p-4 text-center">
                                {/* Icon */}
                                <div
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                    style={{
                                        width: 80,
                                        height: 80,
                                        background: "linear-gradient(135deg, #28a745, #20c997)",
                                    }}
                                >
                                    <i className="bi bi-check-lg" style={{ fontSize: "2.5rem" }} />
                                </div>

                                {/* Title */}
                                <h5 className="fw-bold mb-2">Success</h5>

                                {/* Message */}
                                <p className="text-muted mb-4">{successMessage}</p>

                                {/* Action */}
                                <Button
                                    variant="success"
                                    className="px-4 fw-semibold rounded-pill"
                                    onClick={() => setSuccessModal(false)}
                                >
                                    Done
                                </Button>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>

        </>
    );

}
